import { Injectable } from '@angular/core';

@Injectable()
export class BrowserDetectionService {

  private readonly browsersAllow = [
    'chrome',
    'firefox',
    'safari',
    'edge'
  ];

  isAnAllowedBrowser(): boolean {
    let allowAccess = false;
    const agent = window.navigator.userAgent.toLowerCase();
    this.browsersAllow.forEach(browser => {
      if (agent.indexOf(browser) > -1) allowAccess = true;
    });
    return allowAccess;
  }
}
